var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from "react";
import { ArticlesFeaturedWrapper, ArticlesFeaturedGrid } from "./ArticlesFeatured.styled";
import CardArticle from "../../components/CardArticle";

var ArticlesFeatured = function ArticlesFeatured(_a) {
  var articles = _a.articles,
      props = __rest(_a, ["articles"]);

  return React.createElement(ArticlesFeaturedWrapper, __assign({}, props), React.createElement(ArticlesFeaturedGrid, null, articles.map(function (data, index) {
    return React.createElement(CardArticle, __assign({}, data, {
      key: "featured-article-" + data.title,
      type: index === 0 ? "big" : "horizontal"
    }));
  })));
};

export default ArticlesFeatured;